//@flow
import {type LocaleNameSpaceState} from '$src/i18n/types'
import {type StoreState} from '$src/state/types'

export const selectLocale = (state: StoreState): LocaleNameSpaceState =>
  state.locale



// WEBPACK FOOTER //
// ./src/i18n/selectors.js